import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { RegistrationFormService } from '../../../services/registration-form.service';

@Component({
  selector: 'app-utility-registration',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './utility-registration.component.html',
  styleUrls: ['./utility-registration.component.scss']
})
export class UtilityRegistrationComponent {
  private readonly fb = inject(FormBuilder);
  private readonly formService = inject(RegistrationFormService);
  private readonly router = inject(Router);

  message = '';
  readonly form = this.fb.nonNullable.group({
    utility_name: ['', [Validators.required]],
    utility_category: ['', [Validators.required]],
    buyer_type: ['', [Validators.required]],
    license_number: ['', [Validators.required]],
    peak_demand_mw: ['', [Validators.required]],
    loss_percentage: ['', [Validators.required]],
    address_line1: ['', [Validators.required]],
    address_line2: [''],
    city_town: ['', [Validators.required]],
    district: ['', [Validators.required]],
    state: ['', [Validators.required]],
    pin_code: ['', [Validators.required]],
    country: ['India', [Validators.required]],
    contact_person_name: ['', [Validators.required]],
    designation: [''],
    mobile_number: ['', [Validators.required]],
    email_address: ['', [Validators.required, Validators.email]],
    alternate_mobile: [''],
    alternate_email: [''],
    document_one: [''],
    document_two: [''],
    document_three: [''],
    declaration_accept: [false, [Validators.requiredTrue]]
  });

  readonly documents = [
    'MERC Distribution / Trading License',
    'Tariff Order / Approval',
    'Network Topology Map'
  ];

  private buildUsername(entityName: string): string {
    const slug = entityName.toLowerCase().replace(/[^a-z0-9]+/g, '.').replace(/^\.+|\.+$/g, '');
    return `${slug || 'utility'}-${Date.now().toString(36)}`;
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const raw = this.form.getRawValue();
    const entityName = raw.utility_name || 'Utility Registration';
    this.formService.submit({
      entity_type: 'UTILITY_REGISTRATION',
      entity_name: entityName,
      username: this.buildUsername(entityName),
      email: raw.email_address || '',
      mobile: raw.mobile_number || null,
      payload_json: {
        ...raw,
        category: 'UTILITY',
        documents: this.documents
      },
      documents: []
    }).subscribe({
      next: (response) => {
        this.message = 'Utility registration submitted successfully.';
        void this.router.navigate(['/register/utility/confirmation'], {
          state: {
            registrationNo: response.value === '' ? 'N/A' : response.value.registration_no,
            stakeholderType: 'Utility Registration',
            submittedOn: new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            status: 'Pending Admin Review'
          }
        });
      },
      error: () => {
        this.message = 'Unable to submit utility registration.';
      }
    });
  }
}
